import { combineReducers } from 'redux';

import createNamedWrapperReducer from './name-wrapper-factory';
import httpReducer from './http';
import i18nReducer from './i18n';
import overlayerReducer from './overlayer';
import { waitingRoomsDataReducer } from '../../waiting-rooms/reducers/waiting-rooms';
import { authDataReducer, authUIReducer } from '../../waiting-rooms/reducers/auth';
import { CREATE_WAITING_ROOM_OVERLAYER } from '../../waiting-rooms/constants/overlayers';
import {
    GET_WAITING_ROOMS_REQUEST_NAME, UPSERT_WAITING_ROOM_REQUEST_NAME, DELETE_WAITING_ROOM_REQUEST_NAME,
    START_WAITING_ROOM_REQUEST_NAME, STOP_WAITING_ROOM_REQUEST_NAME, GET_WAITING_ROOM_SESSION_POSITION_REQUEST_NAME,
    GET_WAITING_ROOM_CHART_REQUEST_NAME,
} from '../../waiting-rooms/api/config';

const UIReducers = combineReducers({
    auth: authUIReducer,
    i18n: i18nReducer,
    http: combineReducers({
        [GET_WAITING_ROOMS_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, GET_WAITING_ROOMS_REQUEST_NAME),
        [UPSERT_WAITING_ROOM_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, UPSERT_WAITING_ROOM_REQUEST_NAME),
        [DELETE_WAITING_ROOM_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, DELETE_WAITING_ROOM_REQUEST_NAME),
        [START_WAITING_ROOM_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, START_WAITING_ROOM_REQUEST_NAME),
        [STOP_WAITING_ROOM_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, STOP_WAITING_ROOM_REQUEST_NAME),
        [GET_WAITING_ROOM_SESSION_POSITION_REQUEST_NAME]: createNamedWrapperReducer(
            httpReducer, GET_WAITING_ROOM_SESSION_POSITION_REQUEST_NAME,
        ),
        [GET_WAITING_ROOM_CHART_REQUEST_NAME]: createNamedWrapperReducer(
            httpReducer, GET_WAITING_ROOM_CHART_REQUEST_NAME,
        ),
    }),
    overlayer: combineReducers({
        [CREATE_WAITING_ROOM_OVERLAYER]: createNamedWrapperReducer(overlayerReducer, CREATE_WAITING_ROOM_OVERLAYER),
    }),
});

const dataReducers = combineReducers({
    waitingRooms: waitingRoomsDataReducer,
    auth: authDataReducer,
});

const rootReducer = combineReducers({
    data: dataReducers,
    ui: UIReducers,
});

export default rootReducer;
